import { render, staticRenderFns } from "./loginActive.vue?vue&type=template&id=3f2e32b2&scoped=true&"
import script from "./loginActive.vue?vue&type=script&lang=js&"
export * from "./loginActive.vue?vue&type=script&lang=js&"
import style0 from "./loginActive.vue?vue&type=style&index=0&id=3f2e32b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2e32b2",
  null
  
)

export default component.exports